// 観察記録の入力欄の部品

// react moment
import * as React from 'react';
import  * as moment from 'moment';
// material-ui
import { Button, TextField, Typography } from '@material-ui/core';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
// models
import { KansatsuKiroku } from '../../models/KansatsuKiroku';
import { KansatsuKirokuSubdiv } from '../../models/KansatsuKirokuSubdiv';
import { KansatsuKirokuObsrec } from '../../models/KansatsuKirokuObsrec';

const styles = {
  valueField: {
    width: '150px',
    marginRight: '5px'
  },
  rowDark: {
    backgroundColor: '#3f51b514'
  }
};

interface OwnProps {
  data: KansatsuKiroku | KansatsuKirokuSubdiv | KansatsuKirokuObsrec;
  disabled: boolean;
  // trueの場合ボタンを非表示にする（主に印刷時）
  hideButtons?: boolean;
}
interface OwnState {
  // 入力項目に対するState
  kansatsuDate: string;
  sokutenNumber: string;
  danmenNumber: string;
  kyori: string;
  kansatsuDateMemo: string;
  sokutenNumberMemo: string;
  danmenNumberMemo: string;
  kyoriMemo: string;
  freeInputs: Array<{
    title: string;
    value: string;
    memo: string;
  }>
}
class KansatsuKirokuEdit extends React.Component<OwnProps, OwnState>{
  constructor(props) {
    super(props);
    this.state = {
      kansatsuDate: '',
      sokutenNumber: '',
      danmenNumber: '',
      kyori: '',
      kansatsuDateMemo: '',
      sokutenNumberMemo: '',
      danmenNumberMemo: '',
      kyoriMemo: '',
      freeInputs: []
    };
  }
  componentWillReceiveProps(newProps: OwnProps) {
    this.setState({
      kansatsuDate: newProps.data.kansatsuDate ||  moment().format('YYYY-MM-DD'),
      sokutenNumber: newProps.data.sokutenNumber || '',
      danmenNumber: newProps.data.danmenNumber || '',
      kyori: newProps.data.kyori || '',
      kansatsuDateMemo: newProps.data.kansatsuDateMemo || '' ,
      sokutenNumberMemo: newProps.data.sokutenNumberMemo || '',
      danmenNumberMemo: newProps.data.danmenNumberMemo || '',
      kyoriMemo: newProps.data.kyoriMemo || '',
      freeInputs: newProps.data.freeInputs || []
    })
  }
  appendFreeInput() {
    const inputs = this.state.freeInputs;
    inputs.push({ title: '', value: '', memo: '' });
    this.setState({ freeInputs: inputs });
  }
  /**
   * 自由記入欄をレンダリングする
   */
  renderFreeInputArea({ index }: { index: number }) {
    return (
      <tr key={`freeInput_${index}`} style={(index % 2 === 0) ? styles.rowDark : {}}>
        <td>
          <TextField
            disabled={this.props.disabled}
            placeholder="見出し"
            onChange={(e) => {
              // 配列を複製する
              const inputs = this.state.freeInputs.slice();
              inputs[index].title = e.target.value;
              this.setState({ freeInputs: inputs });
            }}
            value={this.state.freeInputs[index].title}
          />
        </td>
        <td>
          <TextField
            disabled={this.props.disabled}
            style={styles.valueField}
            placeholder="値"
            onChange={(e) => {
              // 配列を複製する
              const inputs = this.state.freeInputs.slice();
              inputs[index].value = e.target.value;
              this.setState({ freeInputs: inputs });
            }}
            value={this.state.freeInputs[index].value}
          />
          <TextField
            disabled={this.props.disabled}
            placeholder="備考"
            onChange={(e) => {
              // 配列を複製する
              const inputs = this.state.freeInputs.slice();
              inputs[index].memo = e.target.value;
              this.setState({ freeInputs: inputs });
            }}
            value={this.state.freeInputs[index].memo}
          />
        </td>
        <td>
          {
            this.props.hideButtons
              ? null
              : (
                <Button
                  disabled={this.props.disabled}
                  size="small"
                  onClick={() => {
                    // 配列を複製する
                    const inputs = this.state.freeInputs.slice();
                    // 現在位置から1要素を削除する
                    inputs.splice(index, 1);
                    this.setState({ freeInputs: inputs });
                  }}
                >
                  <RemoveCircle style={{ color:'red' }}/>
                </Button>
              )
          }
        </td>
      </tr>

    );
  }

  /**
   * 外部から値を取得する
   */
  get() {
    return {
      ...this.state
    };
  }
  render() {
    return (
          <div
            style={{
              // display: this.props.inferenceResult.loaded ? 'block': 'none',
              marginTop: '10px',
              marginBottom: '10px'
            }}
          >
            <table style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td style={{ width: '170px' }}>観察年月日</td>
                  <td colSpan={2}>
                    {/* // ボタン非表示のときはテキストとして扱う */}
                    {
                      this.props.hideButtons
                        ? (
                          <TextField
                            disabled={this.props.disabled}
                            type="text"
                            onChange={(e) => this.setState({ kansatsuDate: e.target.value || moment().format('YYYY-MM-DD')})}
                            value={moment(this.state.kansatsuDate).format('YYYY/MM/DD')}
                            style={styles.valueField}
                          />
                        )
                        : (
                          <TextField
                            disabled={this.props.disabled}
                            type="date"
                            onChange={(e) => this.setState({ kansatsuDate: e.target.value || moment().format('YYYY-MM-DD')})}
                            value={this.state.kansatsuDate}
                            style={styles.valueField}
                          />
                        )
                    }
                    <TextField placeholder="備考"
                      onChange={(e) => this.setState({ kansatsuDateMemo: e.target.value })}
                      value={this.state.kansatsuDateMemo}
                    />
                  </td>
                </tr>
                <tr style={styles.rowDark}>
                  <td>測点No.</td>
                  <td colSpan={2}>
                    <TextField
                      disabled={this.props.disabled}
                      onChange={(e) => this.setState({ sokutenNumber: e.target.value })}
                      value={this.state.sokutenNumber}
                      style={styles.valueField}
                    />
                    <TextField placeholder="備考"
                      disabled={this.props.disabled}
                      onChange={(e) => this.setState({ sokutenNumberMemo: e.target.value })}
                      value={this.state.sokutenNumberMemo}
                    />
                  </td>
                </tr>
                <tr>
                  <td>断面番号</td>
                  <td colSpan={2}>
                    <TextField
                      disabled={this.props.disabled}
                      onChange={(e) => this.setState({ danmenNumber: e.target.value })}
                      value={this.state.danmenNumber}
                      style={styles.valueField}
                    />
                    <TextField placeholder="備考"
                      disabled={this.props.disabled}
                      onChange={(e) => this.setState({ danmenNumberMemo: e.target.value })}
                      value={this.state.danmenNumberMemo}
                    />
                  </td>
                </tr>
                <tr style={styles.rowDark}>
                  <td>坑口からの距離[m]</td>
                  <td colSpan={2}>
                    <TextField
                      disabled={this.props.disabled}
                      onChange={(e) => this.setState({ kyori: e.target.value })}
                      value={this.state.kyori}
                      style={styles.valueField}
                    />
                    <TextField placeholder="備考"
                      disabled={this.props.disabled}
                      onChange={(e) => this.setState({ kyoriMemo: e.target.value })}
                      value={this.state.kyoriMemo}
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan={2} style={{ paddingTop: '10px' }}><Typography variant="body2">自由記入欄</Typography></td>
                </tr>
                {
                  this.state.freeInputs.map((item, index) => this.renderFreeInputArea({ index }))
                }
                <tr>
                  <td colSpan={3}>
                    {
                      this.props.hideButtons
                        ? null
                        : (
                          <Button
                            disabled={this.props.disabled}
                            variant="contained"
                            color="primary"
                            onClick={() => this.appendFreeInput()}
                          >
                            自由記入欄を追加
                          </Button>
                        )
                    }
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
      );
  }
}
export default KansatsuKirokuEdit;






// WEBPACK FOOTER //
// ./src/components/parts/KansatsuKirokuEdit.tsx